// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"91b1220b","702":"c0918f64"}[chunkId] + ".chunk.js";
};